import { createStore } from 'vuex';



const store = createStore({
    state:{
        lang: 'it',
        userIsLoggedIn: false,
        userData: null,
        erroreGenericoApplicazione: false,
        libraryWiperConfig: {},
        surveyLogId: null
    },
    mutations:{
      changeLanguage(state,lang){
        switch(lang){
          case 'it':
          case 'en':
            state.lang = lang;
        }
      },
      showErroreGenerico(state){
        state.erroreGenericoApplicazione = true;
      },
      hideErroreGenerico(state){
        state.erroreGenericoApplicazione = false;
      },
      login(state){
        state.userIsLoggedIn = true;
      },
      logout(state){
        state.userIsLoggedIn = false;
        state.userData = null;
      },
      setUserData(state,userData){
        state.userData = userData
      },
      setLibraryWiperConfig(state,config){
        state.libraryWiperConfig = config
      },
      setSurveyLogId(state, value) {
        state.surveyLogId = value;
      },
      
    },
    actions:{
      CHECK_USER_ALREADY_LOGGED({commit,dispatch}) {
        if (localStorage.getItem(process.env.VUE_APP_TOKEN_ID) && localStorage.getItem("last_user_id")) {
          commit("login")
        }
      },
      SHOW_ERRORE_GENERICO({commit,dispatch}) {
        commit("showErroreGenerico")
      },
      HIDE_ERRORE_GENERICO({commit,dispatch}) {
        commit("hideErroreGenerico")
      },
      SAVE_SURVEY_LOG({ state, commit }, value) {
        if (state.libraryWiperConfig?.ricordaRisposteQuestionario?.toLowerCase() === 'true') {
          // Se remember è true, salva nel localStorage
          
          localStorage.setItem(state.libraryWiperConfig.lastSurveyLocalstorageId, value);
        } else {
          // Altrimenti, aggiorna lo stato Vuex
          commit("setSurveyLogId", value);
        }
      },
      DELETE_SURVEY_LOG({ state, commit }, value) {
        if (state.libraryWiperConfig?.ricordaRisposteQuestionario?.toLowerCase() === 'true') {
          // Se remember è true, salva nel localStorage
          
          localStorage.removeItem(state.libraryWiperConfig.lastSurveyLocalstorageId);
        } else {
          // Altrimenti, aggiorna lo stato Vuex
          commit("setSurveyLogId", null);
        }
      },
      
       
    },
    getters:{
      getSurveyLogId: state => {
        if (state.libraryWiperConfig?.ricordaRisposteQuestionario?.toLowerCase() === 'true') {
          // Se remember è true, restituisce il valore dal localStorage
          return localStorage.getItem(state.libraryWiperConfig.lastSurveyLocalstorageId) || null;
        }
        // Altrimenti, restituisce il valore dallo stato Vuex
        return state.surveyLogId;
      },

    },
    modules:{
      
    },


})
  export default store;
